// Sound Brothers: alle externen Links öffnen in neuem Tab.
//
// Sucht überall in RTE-Inhalten (Produktbeschreibungen, Metafelder, Tabs, Pages, Blog)
// nach <a href="…">-Tags, deren Ziel-Host NICHT der eigene Shop ist, und ergänzt
//   target="_blank"
//   rel="noopener noreferrer"
//
// Interne Links (relative Pfade, /collections/…, /products/…, Anker #, mailto:, tel:)
// bleiben unverändert — sollen ja im selben Tab bleiben.

(function () {
  const SELECTORS = [
    '.rte a[href]',
    '.product__description a[href]',
    '.sb-product-tabs__panel a[href]',
    '.sb-product-tabs__content a[href]',
    '.metafield-rich_text_field a[href]',
    '.page-width .rte a[href]',
    '.shopify-section a[href]',
  ];

  function isExternal(href, currentHost) {
    if (!href) return false;
    // Relative / Anker / Spezial-Schemes überspringen
    if (href.startsWith('#') || href.startsWith('/') || href.startsWith('?')) return false;
    if (/^(mailto|tel|sms|javascript):/i.test(href)) return false;
    try {
      const url = new URL(href, window.location.origin);
      return url.hostname && url.hostname !== currentHost;
    } catch (e) {
      return false;
    }
  }

  function annotate(root) {
    const host = window.location.hostname;
    const seen = new Set();
    for (const sel of SELECTORS) {
      root.querySelectorAll(sel).forEach((a) => {
        if (seen.has(a)) return;
        seen.add(a);
        const href = a.getAttribute('href');
        if (!isExternal(href, host)) return;
        a.setAttribute('target', '_blank');
        // Bestehende rel-Werte respektieren
        const rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
        if (!rel.includes('noopener')) rel.push('noopener');
        if (!rel.includes('noreferrer')) rel.push('noreferrer');
        a.setAttribute('rel', rel.join(' '));
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => annotate(document));
  } else {
    annotate(document);
  }

  // Falls Sections im Theme-Editor live nachgeladen werden
  document.addEventListener('shopify:section:load', (e) => annotate(e.target));
})();
